import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { showQuestionModal } from "../components/modals/QuestionModal";
import { translate } from "../core/i18n";
import { getCloudUser } from "./cloudstorage/cloud";
import { userHasRoleFromList } from "./cloudstorage/user";
import { redirectToNewTab, redirectTo } from "./redirect";

const requestedLinkNavigation = (item : any) => {
  const shouldOpenInNewWindow = item.newWindow !== false; // default to true if not specified
  const redirectFunction = shouldOpenInNewWindow ? redirectToNewTab : redirectTo;
  
  if (item.askForAction === false) {
    redirectFunction(item.url);
    return;
  }
  const title = item.title ? item.title : translate("nav-external-link-title")
  const text = item.modalText ? item.modalText : translate("nav-external-link-text")
  const opts = {
    okTitle: item.modalOk ? item.modalOk : translate("nav-external-link-ok"),
    cancelTitle : item.modalCancel ? item.modalCancel : translate("modal-cancel"),
  }
  showQuestionModal(title, text, () => { redirectFunction(item.url) }, () => {}, opts);
}

export const getCustomMenuItem = (item, index, classes?) => {

  if (item.anonymous && getCloudUser().loggedIn === true) {
    return null;
  } else if (item.anonymous === false && getCloudUser().loggedIn === false) {
    return null;
  } else if (item.caps) {
    if (!getCloudUser().loggedIn || !userHasRoleFromList(item.caps)) {
      return null;
    }
  }

  const title = item.title ? item.title : null;
  const icon = item.icon ? <FontAwesomeIcon icon={item.icon} /> : null;
  const content = <>{icon} {title}</>;

  if (item.type === "link" && classes === undefined) {
    return <a href={item.url} className={'menu-item'} onClick={(e) => { e.preventDefault(); requestedLinkNavigation(item); }} key={index} style={{ color: 'inherit', textDecoration: 'none' }}>{content}</a>;
  } else {
    const buttonClasses = item.type === "button" ? "btn btn-primary " : "";
    return <button onClick={() => requestedLinkNavigation(item)} className={buttonClasses + (classes || '')} key={index}>{content}</button>;
  }
}
